import { useLayoutEffect } from "react";

interface OpenChangeObserverProps {
  open: boolean;
  onOpenChange?: (open: boolean) => void;
}

/**
 * Reports Headless UI open state to a consumer callback.
 *
 * Rendered as a child of the render prop so the notification happens in a real
 * component's layout effect instead of a hook called inside a render function,
 * which would break the rules of hooks whenever the parent re-renders.
 */
export default function OpenChangeObserver({
  open,
  onOpenChange,
}: OpenChangeObserverProps) {
  useLayoutEffect(() => {
    onOpenChange?.(open);
  }, [open, onOpenChange]);
  return null;
}
